/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Source of the suggestion
 */
export enum SearchSuggestionType {
  category = 'category',
  activity = 'activity'
}
